<template>
  <notifications position="bottom right" />

  <!-- Pineapple shell: full admin layout -->
  <div v-if="showSidenav" class="p-app" :class="{ 'p-app--sidebar-collapsed': isSidebarCollapsed }">
    <AdminSidebar />
    <div class="p-app__main">
      <AdminTopbar />
      <main class="p-app__content">
        <router-view />
      </main>
    </div>
  </div>

  <!-- Empty layout (auth pages, popups): no shell -->
  <main v-else class="p-app-empty">
    <router-view />
  </main>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AdminSidebar from "@/components/Pineapple/AdminSidebar.vue";
import AdminTopbar from "@/components/Pineapple/AdminTopbar.vue";

export default {
  name: "App",
  components: {
    AdminSidebar,
    AdminTopbar,
  },
  computed: {
    ...mapState([
      "showSidenav",
    ]),
    ...mapGetters("layout", ["isSidebarCollapsed"]),
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/pineapple";

.p-app {
  min-height: 100vh;
  background: $p-bg;
  color: $p-ink;
  font-family: $p-font-body;
}

.p-app__main {
  margin-left: 256px;
  min-height: 100vh;
  transition: margin-left 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 0;

  .p-app--sidebar-collapsed & {
    margin-left: 64px;
  }
}

.p-app__content {
  flex: 1;
  padding: 0 24px 36px;
  margin: 0;

  // First child sits flush against the topbar (no leftover top margin).
  > *:first-child {
    margin-top: 0 !important;
  }
}

.p-app-empty {
  min-height: 100vh;
  background: $p-bg;
}

// vue3-notification group must stay fixed-positioned with no flow margin
// (it appears before .p-app in App.vue's multi-root template; if it had a
// flow margin it would push the entire app down).
.vue-notification-group {
  position: fixed !important;
  margin: 0 !important;
}

// Legacy custom modal-overlay used by existing Bootstrap modals
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  position: relative;
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1050;
  max-width: 600px;
  width: 100%;
}

.modal-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: #333;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1051;
}
.modal-close-btn:hover { color: #000; }
</style>
